/**
 * UBG Left Column 
 * Attila Németh, UBG
 * 18.09.2018
 */
 
import {Component} from '@angular/core';

@Component({
  selector: 'ubg-left-column',
  templateUrl: './left_column.component.html',
})
export class UbgLeftColumnComponent {
}